import { render, staticRenderFns } from "./OrderPaymentModal.vue?vue&type=template&id=433120df"
import script from "./OrderPaymentModal.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports